import { render, staticRenderFns } from "./InstitutionTypeView.vue?vue&type=template&id=4455911c"
import script from "./InstitutionTypeView.vue?vue&type=script&lang=js"
export * from "./InstitutionTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports